import { TmBaseError } from '@/core/error/tmBaseError'

export class TmMissingComponentScopeError extends TmBaseError {
  public name = 'TmMissingComponentScopeError'
}
